import React from 'react';

import * as ST from './styled';

const Offer: React.FC = () => {

    return (
        <>
            <ST.Offer>
                {'Нажимая на кнопку, вы даёте согласие на обработку'}&nbsp;
            </ST.Offer>
            <ST.Offer>
                <ST.OfferLink href='https://dom.ru/policy.pdf' target='_blank' rel='nofollow noopener'>
                    {'\nперсональных данных'}
                </ST.OfferLink>
            </ST.Offer>
        </>
    );
};

export default Offer;
